import { Component, Inject } from '@angular/core';
import { ListBase } from "../shared/list.base";
import { CrewPermissionsService } from '../../core/crew-permissions.service';

@Component({
    selector: 'crew-competencetypes',
    template: require('./competencetypes.component.html')
})
export class CompetenceTypes extends ListBase<Nema.Crew.Model.CompetenceType>  {

    constructor(
        @Inject("competenceTypes") public competenceTypes: Nema.Crew.Model.CompetenceType[],
        @Inject("competenceGroups") public competenceGroups: Nema.Crew.Model.CompetenceGroup[],
        crewPermissionsService: CrewPermissionsService) {

        super(competenceTypes, crewPermissionsService);
    }

    public newEntityState = "app.settings.competencetypes.new";

    public editEntityState = "app.settings.competencetypes.detail";

    public entityName = "Competence";

    public entityNames = "Competences";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/competencetypes/competencetypes.component.ts